<template>
  <div>
    <OptinModal :isActive="isOptinModalActive" @accepted="closeOptinModal" ref="optinModal" />
    <div class="columns is-multiline">
      <div class="column is-12-desktop is-6-widescreen">
        <h3 class="title mb-1 is-size-4 is-size-5-mobile">{{ $t('payment.paypal.header') }}</h3>
        <p class="mb-4">
          {{ $t('payment.paypal.pay_with_two_clicks') }}
        </p>
        <p class="notification is-danger has-text-centered pt-1 pb-1" v-show="showTosError">
          {{ $t('errors.tos-not-accepted') }}
        </p>
        <p class="notification has-text-centered  is-success pt-1 pb-1" v-show="tosAccepted">
          {{ $t('payment.paypal.tos-accepted') }}
        </p>
      </div>
      <div class="column is-12-desktop is-6-widescreen" v-if="button">
        <div id="paypal-button-container">
            <component  v-bind:is="button" :on-approve="onApprove" :create-order="createOrder" :on-init="onInit" :on-click="onClick" :on-error="onError" :style-object="style"  />
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import PayPalApi from '@/api/paypal-api'
import OrderValidator from '@/api/order-validator'
import OptinModal from './OptinModal'
import {mapGetters} from 'vuex'
import Vue from 'vue'

const loadPaypal = () =>
  new Promise(resolve => {
    if (window.paypal) {
      resolve(window.paypal)
    } else {
      //paypal language doku
      //https://developer.paypal.com/docs/business/javascript-sdk/javascript-sdk-configuration/#locale
      let ppSmartButtons = document.createElement('script')
      //&locale=${this.$store.getters.localeIso}
      ppSmartButtons.setAttribute('src', `https://www.paypal.com/sdk/js?client-id=${process.env.VUE_APP_PP_CLIENTID}&currency=${process.env.VUE_APP_CURRENCY}`)
      ppSmartButtons.onload = () => {
        resolve(window.paypal)
      }
      document.head.appendChild(ppSmartButtons)
    }
  })

//adapted to https://developer.paypal.com/docs/checkout/standard/customize/single-page-app/#vue
export default {
  name: 'PayPalButtonsX',
  components: {OptinModal},
  data() {
    return {
      isOptinModalActive: false,
      showTosError: false,
      tosAccepted: false,
      button: null,
    }
  },
  computed: {
    ...mapGetters({
      locale: 'locale',
    }),
    createOrder: function() {
      return async data => {
        let res = await OrderValidator.validateOrder()
        if (res.validForSale) {
          await this.$store.dispatch('$_checkout/updateOptinOptions')
          data = await PayPalApi.createPayPalOrder()
          if (data.continue) {
            return data.orderID
          } else {
            this.$store.dispatch('refreshCart', {delegateCustomer: true})
            throw new Error('Closed Order')
          }
        } else {
          OrderValidator.invalidOrderHandler(res)
          throw new Error('Inconsistent Order')
        }
      }
    },
    onClick() {
      return () => {
        if (!this.tosAccepted && !this.isOptinModalActive) {
          this.isOptinModalActive = true
        }
      }
    },
    onInit() {
      return (data, actions) => {
        actions.disable()
        this.$on('redirect-further', value => {
          if (value) {
            actions.enable()
            this.showTosError = false
          } else {
            actions.disable()
            this.showTosError = true
          }
        })
      }
    },
    onApprove() {
      return (data, actions) => {
        this.$store.dispatch('lockSite')
        return actions.order.capture().then(details => {
          this.$buefy.notification.open({
            message: `${this.$t('payment.paypal.verify-dialog_one')} ${details.payer.name.given_name}, ${this.$t('payment.paypal.verify-dialog_two')} ${details.purchase_units[0].amount.value}, ${this.$t('payment.paypal.verify-dialog_three')}`,
            position: 'is-top',
            type: 'is-success',
            hasIcon: true,
          })
          this.$store.dispatch('$_checkout/completePayPal', {
            orderId: data.orderID,
            details: details,
          })
        })
      }
    },
    onError() {
      return err => {
        this.$buefy.notification.open({
            message: `Unknown error: ${err}`,
            position: 'is-top',
            type: 'is-danger',
            hasIcon: true,
          })
        console.error(err)
      }
    },
    style: function () {
        return {
            layout: 'vertical',
        }
      },
  },
  methods: {
    closeOptinModal(closed) {
      this.isOptinModalActive = false
      this.$emit('redirect-further', closed)
      this.tosAccepted = closed
    },
    loadPaypal() {
      return new Promise(resolve => {
        if (window.paypal) {
          resolve(window.paypal)
        } else {
          //paypal language doku
          //https://developer.paypal.com/docs/business/javascript-sdk/javascript-sdk-configuration/#locale
          let ppSmartButtons = document.createElement('script')
          ppSmartButtons.setAttribute('src', `https://www.paypal.com/sdk/js?client-id=${process.env.VUE_APP_PP_CLIENTID}&currency=${process.env.VUE_APP_CURRENCY}&locale=${this.$store.getters.localeIso}`)
          ppSmartButtons.onload = () => {
            resolve(window.paypal)
          }
          document.head.appendChild(ppSmartButtons)
        }
      })
    },
  },
  beforeMount() {},
  async mounted() {
    const paypal = await loadPaypal()
    const PayPalButton = paypal.Buttons.driver('vue', Vue)
    this.button = PayPalButton
  },
}
</script>

<style scoped lang="scss">
//fix for not overlaying navigation
#paypal-button-container {
  position: relative;
  z-index: 1;
}
</style>
